import { Group, Skeleton, Stack } from "@mantine/core";

const DrawerSkeleton = () => (
  <Stack gap={0} className="h-full">
    {/* Header skeleton */}
    <div className="px-4 py-4 border-b border-gray-100">
      <Group gap={12} align="flex-start" wrap="nowrap">
        <Skeleton circle height={48} width={48} />
        <Stack gap={6} style={{ flex: 1 }}>
          <Skeleton height={18} width="60%" radius={4} />
          <Skeleton height={12} width="40%" radius={4} />
          <Skeleton height={12} width="30%" radius={4} />
        </Stack>
      </Group>
    </div>

    {/* Tabs skeleton */}
    <div className="px-4 py-3 border-b border-gray-100">
      <Group gap={16}>
        <Skeleton height={10} width={60} radius={4} />
        <Skeleton height={10} width={50} radius={4} />
        <Skeleton height={10} width={55} radius={4} />
        <Skeleton height={10} width={45} radius={4} />
      </Group>
    </div>

    {/* Content skeleton — property rows */}
    <Stack gap={0} className="px-4 py-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="flex items-center justify-between py-3 border-b border-gray-50">
          <Skeleton height={10} width={`${30 + Math.random() * 20}%`} radius={4} />
          <Skeleton height={10} width={`${20 + Math.random() * 15}%`} radius={4} />
        </div>
      ))}
    </Stack>
  </Stack>
);

export default DrawerSkeleton;
